import React, { useState } from 'react';
import './token.scss';
import { tokensImages } from '../../../types/helpers';
import Nulo from '../../../assets/images/icons/null.png';

type SelectProps = {
    onChange: (e:any) => void
}

const img = tokensImages;

const tokens = [
    { token: 'USDT', name:'Tether', id:0 , networks: [], img: img.usdt },
    { token: 'USDC', name:'Usdc', id:1 , networks: [], img: img.usdc },
    { token: 'BTC', name:'Bitcoin', id:2 , networks: [], img: img.btc },
    { token: 'TON', name:'Toncoin', id:3 , networks: [], img: img.ton }
]

export const TokenSelector : React.FC<SelectProps> = (props) => {

    const [img, setImg] = useState(Nulo)

    const handleChange = (e:any) => {
        const tokenSplit = e.target.value.split(" ")[0];
        const current = tokens.filter( token => token.name === tokenSplit)[0]
        setImg(current.img);
        props.onChange(e.target.value);
    }

    return (
        <div className="select-wrapper">
            <select name="" id="" onChange={handleChange}>
                <option value=''>Selecione o token</option>
                {tokens.map( (t:any) => (
                    <option key={t.id}>
                        { t.name } ({ t.token })
                    </option>
                ))}
            </select>

            <img alt='token icon' src={img} className={ img === Nulo ? 'nulo' : ''}/>
          </div>
    )
}